/*
  This file bridges the module helpers into the global scope
*/

import helpers from './helpers.js';

//make the helpers available to the outside
window.Helpers = helpers.methods;